export const INTERNAL_EMAIL_DOMAIN = 'tundr.tech';

/** HR “internal user” flag from company contact email (Amplitude / Intercom). */
export const isInternalHrUserByEmail = (email?: string): boolean =>
  Boolean(email?.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN));
